// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pill-box-two-sided-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 83%;
  margin: 0 auto;
}

.pill-box-two-sided-left-half-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
  height: 40px;
}
@media (max-width: 900px) {
  .pill-box-two-sided-left-half-container {
    height: 25px;
  }
}

.pill-box-two-sided-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #fff;
}
@media (max-width: 900px) {
  .pill-box-two-sided-text {
    font-size: 11px !important;
  }
}

.pill-box-two-sided-right-half-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 8px 8px 0px;
  height: 40px;
}
@media (max-width: 900px) {
  .pill-box-two-sided-right-half-container {
    height: 25px;
  }
}

.pill-box-with-text-left-half-text {
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #fff;
}
@media (max-width: 900px) {
  .pill-box-with-text-left-half-text {
    font-size: 11px !important;
  }
}

.pill-box-with-text-right-half-text {
  font-size: 16px !important;
  font-weight: 500 !important;
}
@media (max-width: 900px) {
  .pill-box-with-text-right-half-text {
    font-size: 11px !important;
  }
}

.pill-box-with-text-left-half-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px 0px 0px 8px;
  height: 40px;
}

.pill-box-with-text-right-half-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px 8px 8px 0px;
  height: 40px;
}

.pill-box-with-text-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 92%;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/components/GamePageComponents/PercentagePillBox/PillBox.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AADJ;AAGI;EAPJ;IAQQ,YAAA;EAAN;AACF;;AAGA;EACI,0BAAA;EACA,2BAAA;EACA,WAAA;AAAJ;AAEI;EALJ;IAMQ,0BAAA;EACN;AACF;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACJ;AACI;EAPJ;IAQQ,YAAA;EAEN;AACF;;AAEA;EACI,0BAAA;EACA,2BAAA;EACA,WAAA;AACJ;AACI;EALJ;IAMQ,0BAAA;EAEN;AACF;;AAEA;EACI,0BAAA;EACA,2BAAA;AACJ;AACI;EAJJ;IAKQ,0BAAA;EAEN;AACF;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,cAAA;AACJ","sourcesContent":["//PercentagePillBoxTwoSided.js\n\n.pill-box-two-sided-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 83%;\n    margin: 0 auto;\n}\n\n.pill-box-two-sided-left-half-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px 0px 0px 8px;\n    height: 40px;\n\n    @media (max-width: 900px) {\n        height: 25px;\n    }\n}\n\n.pill-box-two-sided-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #fff;\n\n    @media (max-width: 900px) {\n        font-size: 11px !important;\n    }\n}\n\n.pill-box-two-sided-right-half-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 0px 8px 8px 0px;\n    height: 40px;\n\n    @media (max-width: 900px) {\n        height: 25px;\n    }\n}\n\n\n.pill-box-with-text-left-half-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    color: #fff;\n\n    @media (max-width: 900px) {\n        font-size: 11px !important;\n    }\n}\n\n\n.pill-box-with-text-right-half-text {\n    font-size: 16px !important;\n    font-weight: 500 !important;\n\n    @media (max-width: 900px) {\n        font-size: 11px !important;\n    }\n}\n\n\n.pill-box-with-text-left-half-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 8px 0px 0px 8px;\n    height: 40px;\n}\n\n.pill-box-with-text-right-half-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 0px 8px 8px 0px;\n    height: 40px;\n}\n\n.pill-box-with-text-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    width: 92%;\n    margin: 0 auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
